export const STANDARD_DATE_FORMAT = 'DD MMM YYYY';
